// Tracking leve de eventos. Fire-and-forget: nunca bloqueia o usuário,
// nunca lança erro. Em caso de falha de rede, simplesmente perde o evento.
//
// Todo evento é enriquecido com visitor_id + session_id + path atual, para
// que o backend consiga reconstruir jornadas por visitante e por sessão.
import { getVisitorId, getSessionId } from "./session";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const track = (kind, data = {}) => {
    try {
        const enriched = {
            ...data,
            visitor_id: getVisitorId(),
            session_id: getSessionId(),
            path: typeof window !== "undefined" ? window.location.pathname : "/",
        };
        const body = JSON.stringify({ kind, data: enriched });
        const url = `${BACKEND_URL}/api/events`;
        if (typeof navigator !== "undefined" && navigator.sendBeacon) {
            const blob = new Blob([body], { type: "application/json" });
            navigator.sendBeacon(url, blob);
        } else {
            fetch(url, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body,
                keepalive: true,
            }).catch(() => {});
        }
    } catch (_e) {
        /* swallow */
    }
};
